exports.components = {
  "component---src-templates-index-tsx": () => import("./../../../src/templates/index.tsx" /* webpackChunkName: "component---src-templates-index-tsx" */),
  "component---src-templates-speech-tsx": () => import("./../../../src/templates/speech.tsx" /* webpackChunkName: "component---src-templates-speech-tsx" */)
}

